<div [class.two-column-tool-tip]="_showInfo">
    <mat-form-field appearance="fill" [class.small]="_short">
        <mat-label>
            {{ _labelData.label }}
        </mat-label>
        <mat-select [(ngModel)]="_value" (ngModelChange)="valueUpdated($event)" [disabled]="_disabled || _readOnly" [errorStateMatcher]="_matcher" [required]="_required">
            <mat-option *ngFor="let i of _visibleLookUps" [value]="i.value">
                {{ i.description }}
            </mat-option>
        </mat-select>
    </mat-form-field>
    @if (_showInfo) {
        <mat-icon color="primary" [matTooltip]="_toolTip" #tooltip="matTooltip" (click)="tooltip.toggle()">info</mat-icon>
    }
</div>